export default "__VITE_ASSET__9bvsRhhd__"